import { api } from '@/shared/lib/axios.ts';
import type {
  TenantListResponse,
  TenantListParams,
  TenantRow,
  TenantDetail,
  FaixaDesconto,
} from '@/shared/types/tenant.ts';

// Campos de contrato/SLA compartilhados por create e update (todos opcionais).
interface ContratoDTO {
  contratoInicioEm?: string | null;
  slaAlvo?: number | null;
  slaPeriodicidade?: 'MENSAL' | 'ANUAL' | null;
  faixasDesconto?: FaixaDesconto[] | null;
}

export async function listTenants(params: TenantListParams): Promise<TenantListResponse> {
  const { data } = await api.get<TenantListResponse>('/admin/tenants', { params });
  return data;
}

export async function getTenant(id: string): Promise<TenantDetail> {
  const { data } = await api.get<TenantDetail>(`/admin/tenants/${id}`);
  return data;
}

export interface CreateTenantDTO extends ContratoDTO {
  nome: string;
  slug: string;
  urlProbe: string;
  poolIIS?: string | null;
  dominioStatus?: string | null;
}

export interface UpdateTenantDTO extends ContratoDTO {
  nome?: string;
  urlProbe?: string;
  poolIIS?: string | null;
  dominioStatus?: string | null;
}

export async function createTenant(input: CreateTenantDTO): Promise<TenantRow> {
  const { data } = await api.post<TenantRow>('/admin/tenants', input);
  return data;
}

export async function updateTenant(id: string, input: UpdateTenantDTO): Promise<TenantRow> {
  const { data } = await api.put<TenantRow>(`/admin/tenants/${id}`, input);
  return data;
}

export async function activateTenant(id: string): Promise<TenantRow> {
  const { data } = await api.patch<TenantRow>(`/admin/tenants/${id}/activate`);
  return data;
}

export async function deactivateTenant(id: string): Promise<TenantRow> {
  const { data } = await api.patch<TenantRow>(`/admin/tenants/${id}/deactivate`);
  return data;
}

export async function destroyTenant(id: string): Promise<TenantRow> {
  const { data } = await api.delete<TenantRow>(`/admin/tenants/${id}`);
  return data;
}

export async function pauseProbe(id: string): Promise<TenantRow> {
  const { data } = await api.patch<TenantRow>(`/admin/tenants/${id}/pause-probe`);
  return data;
}

export async function resumeProbe(id: string): Promise<TenantRow> {
  const { data } = await api.patch<TenantRow>(`/admin/tenants/${id}/resume-probe`);
  return data;
}

export async function cleanTenantData(
  id: string,
  before?: string,
): Promise<Record<string, number>> {
  // before (ISO) = apagar só o que é anterior ao corte; ausente = apagar todo o histórico.
  const { data } = await api.post<Record<string, number>>(
    `/admin/tenants/${id}/clean-data`,
    before ? { before } : {},
  );
  return data;
}
